/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CancelServiceaftaleRequest as OkEgisServiceModelsDtoCancelServiceaftaleRequest } from '../models/OK/Egis/Service/Models/DTO/cancel-serviceaftale-request';
import { ChangeDto as OkEgisServiceModelsDtoChangeDto } from '../models/OK/Egis/Service/Models/DTO/change-dto';
import { CreateServiceaftaleRequestDto as OkEgisServiceModelsDtoCreateServiceaftaleRequestDto } from '../models/OK/Egis/Service/Models/DTO/create-serviceaftale-request-dto';
import { CreateServiceaftaleResponseDto as OkEgisServiceModelsDtoCreateServiceaftaleResponseDto } from '../models/OK/Egis/Service/Models/DTO/create-serviceaftale-response-dto';
import { DriftformDto as OkEgisServiceModelsDtoDriftformDto } from '../models/OK/Egis/Service/Models/DTO/driftform-dto';
import { KomponentTypeDto as OkEgisServiceModelsDtoKomponentTypeDto } from '../models/OK/Egis/Service/Models/DTO/komponent-type-dto';
import { PartnerInfoDto as OkEgisServiceModelsDtoPartnerInfoDto } from '../models/OK/Egis/Service/Models/DTO/partner-info-dto';
import { ServiceaftaleDatesUpdateDto as OkEgisServiceModelsDtoServiceaftaleDatesUpdateDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-dates-update-dto';
import { ServiceaftaleDto as OkEgisServiceModelsDtoServiceaftaleDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceaftaleRabatUpdateDto as OkEgisServiceModelsDtoServiceaftaleRabatUpdateDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-rabat-update-dto';
import { ServiceaftaleStateDto as OkEgisServiceModelsDtoServiceaftaleStateDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-state-dto';
import { ServiceaftaleTagDto as OkEgisServiceModelsDtoServiceaftaleTagDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-tag-dto';
import { ServiceaftaleUpdateResponseDto as OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto } from '../models/OK/Egis/Service/Models/DTO/serviceaftale-update-response-dto';
import { TerminationCauseDto as OkEgisServiceModelsDtoTerminationCauseDto } from '../models/OK/Egis/Service/Models/DTO/termination-cause-dto';
import { UpcomingChangesDto as OkEgisServiceModelsDtoUpcomingChangesDto } from '../models/OK/Egis/Service/Models/DTO/upcoming-changes-dto';
import { UpdateServiceAbonnementRequestDto as OkEgisServiceModelsDtoUpdateServiceAbonnementRequestDto } from '../models/OK/Egis/Service/Models/DTO/update-service-abonnement-request-dto';
import { FakturaStopRequest as OkEgisServiceModelsRequestFakturaStopRequest } from '../models/OK/Egis/Service/Models/Request/faktura-stop-request';
import { GetServiceaftalerRequest as OkEgisServiceModelsRequestGetServiceaftalerRequest } from '../models/OK/Egis/Service/Models/Request/get-serviceaftaler-request';
import { ReactivateServiceaftaleRequest as OkEgisServiceModelsRequestReactivateServiceaftaleRequest } from '../models/OK/Egis/Service/Models/Request/reactivate-serviceaftale-request';
import { RemoveUpcomingChangesRequest as OkEgisServiceModelsRequestRemoveUpcomingChangesRequest } from '../models/OK/Egis/Service/Models/Request/remove-upcoming-changes-request';
import { UpdateFastOrdreNoteRequest as OkEgisServiceModelsRequestUpdateFastOrdreNoteRequest } from '../models/OK/Egis/Service/Models/Request/update-fast-ordre-note-request';
import { UpdateHenviserRequest as OkEgisServiceModelsRequestUpdateHenviserRequest } from '../models/OK/Egis/Service/Models/Request/update-henviser-request';
import { UpdateMultiplePartnerRequest as OkEgisServiceModelsRequestUpdateMultiplePartnerRequest } from '../models/OK/Egis/Service/Models/Request/update-multiple-partner-request';
import { UpdateOpkraevningsintervalRequest as OkEgisServiceModelsRequestUpdateOpkraevningsintervalRequest } from '../models/OK/Egis/Service/Models/Request/update-opkraevningsinterval-request';
import { UpdateServiceOrdreNoteRequest as OkEgisServiceModelsRequestUpdateServiceOrdreNoteRequest } from '../models/OK/Egis/Service/Models/Request/update-service-ordre-note-request';
import { UpdateServiceabonnementRequest as OkEgisServiceModelsRequestUpdateServiceabonnementRequest } from '../models/OK/Egis/Service/Models/Request/update-serviceabonnement-request';
import { UpdateServiceaftalePartnerRequest as OkEgisServiceModelsRequestUpdateServiceaftalePartnerRequest } from '../models/OK/Egis/Service/Models/Request/update-serviceaftale-partner-request';
import { UpdateTagsRequest as OkEgisServiceModelsRequestUpdateTagsRequest } from '../models/OK/Egis/Service/Models/Request/update-tags-request';
import { ValidateOpkraevningsintervalRequest as OkEgisServiceModelsRequestValidateOpkraevningsintervalRequest } from '../models/OK/Egis/Service/Models/Request/validate-opkraevningsinterval-request';
import { GetServiceaftaleResponse as OkEgisServiceModelsResponseGetServiceaftaleResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceaftale-response';
import { GetServiceaftalerResponse as OkEgisServiceModelsResponseGetServiceaftalerResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceaftaler-response';
import { GetServiceaftalerWithUpcomingChangesResponse as OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceaftaler-with-upcoming-changes-response';
import { UpdateMultiplePartnerResponse as OkEgisServiceModelsResponseUpdateMultiplePartnerResponse } from '../models/OK/Egis/Service/Models/Response/update-multiple-partner-response';
import { ValidateOpkraevningsintervalResponse as OkEgisServiceModelsResponseValidateOpkraevningsintervalResponse } from '../models/OK/Egis/Service/Models/Response/validate-opkraevningsinterval-response';

@Injectable({
  providedIn: 'root',
})
export class ServiceAftaleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getServiceaftaler
   */
  static readonly GetServiceaftalerPath = '/api/v1/ServiceAftale/GetServiceaftaler';

  /**
   * Gets a page of serviceaftaler.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaler()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceaftaler$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetServiceaftalerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftalerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerResponse>;
      })
    );
  }

  /**
   * Gets a page of serviceaftaler.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaler$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceaftaler(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetServiceaftalerRequest
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalerResponse> {

    return this.getServiceaftaler$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalerResponse)
    );
  }

  /**
   * Path part for operation getServiceaftalerWithUpcomingChanges
   */
  static readonly GetServiceaftalerWithUpcomingChangesPath = '/api/v1/ServiceAftale/GetServiceaftalerWithUpcomingChanges';

  /**
   * Gets a page of serviceaftaler.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftalerWithUpcomingChanges()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceaftalerWithUpcomingChanges$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetServiceaftalerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftalerWithUpcomingChangesPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse>;
      })
    );
  }

  /**
   * Gets a page of serviceaftaler.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftalerWithUpcomingChanges$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getServiceaftalerWithUpcomingChanges(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetServiceaftalerRequest
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse> {

    return this.getServiceaftalerWithUpcomingChanges$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse)
    );
  }

  /**
   * Path part for operation getMineServiceaftaler
   */
  static readonly GetMineServiceaftalerPath = '/api/v1/ServiceAftale/GetMineServiceaftaler';

  /**
   * Gets my recent serviceaftaler.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMineServiceaftaler()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMineServiceaftaler$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetMineServiceaftalerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleDto>>;
      })
    );
  }

  /**
   * Gets my recent serviceaftaler.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMineServiceaftaler$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMineServiceaftaler(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceaftaleDto>> {

    return this.getMineServiceaftaler$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceaftaleDto>)
    );
  }

  /**
   * Path part for operation getServiceaftale
   */
  static readonly GetServiceaftalePath = '/api/v1/ServiceAftale/GetServiceaftale/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftale()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftale$Response(params: {
    id: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftalePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftale$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftale(params: {
    id: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.getServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation getFutureserviceaftalerForPartner
   */
  static readonly GetFutureserviceaftalerForPartnerPath = '/api/v1/ServiceAftale/GetFutureserviceaftalerForPartner';

  /**
   * Gets service aftale which in the future will change to the partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFutureserviceaftalerForPartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFutureserviceaftalerForPartner$Response(params: {
    partnerNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetFutureserviceaftalerForPartnerPath, 'get');
    if (params) {
      rb.query('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse>;
      })
    );
  }

  /**
   * Gets service aftale which in the future will change to the partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFutureserviceaftalerForPartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFutureserviceaftalerForPartner(params: {
    partnerNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse> {

    return this.getFutureserviceaftalerForPartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalerWithUpcomingChangesResponse)
    );
  }

  /**
   * Path part for operation getServiceaftaleByNo
   */
  static readonly GetServiceaftaleByNoPath = '/api/v1/ServiceAftale/GetServiceaftaleByNo/{serviceaftaleNo}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaleByNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleByNo$Response(params: {
    serviceaftaleNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftaleByNoPath, 'get');
    if (params) {
      rb.path('serviceaftaleNo', params.serviceaftaleNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaleByNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleByNo(params: {
    serviceaftaleNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.getServiceaftaleByNo$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation createServiceaftale
   */
  static readonly CreateServiceaftalePath = '/api/v1/ServiceAftale/CreateServiceaftale';

  /**
   * Creates a new Serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createServiceaftale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createServiceaftale$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateServiceaftaleRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoCreateServiceaftaleResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.CreateServiceaftalePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoCreateServiceaftaleResponseDto>;
      })
    );
  }

  /**
   * Creates a new Serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createServiceaftale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createServiceaftale(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateServiceaftaleRequestDto
  }): Observable<OkEgisServiceModelsDtoCreateServiceaftaleResponseDto> {

    return this.createServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoCreateServiceaftaleResponseDto>) => r.body as OkEgisServiceModelsDtoCreateServiceaftaleResponseDto)
    );
  }

  /**
   * Path part for operation getAvailableDriftformer
   */
  static readonly GetAvailableDriftformerPath = '/api/v1/ServiceAftale/GetAvailableDriftformer';

  /**
   * Returns a list of available driftformer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableDriftformer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDriftformer$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoDriftformDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetAvailableDriftformerPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoDriftformDto>>;
      })
    );
  }

  /**
   * Returns a list of available driftformer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableDriftformer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableDriftformer(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoDriftformDto>> {

    return this.getAvailableDriftformer$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoDriftformDto>>) => r.body as Array<OkEgisServiceModelsDtoDriftformDto>)
    );
  }

  /**
   * Path part for operation getAvailableKomponentTyper
   */
  static readonly GetAvailableKomponentTyperPath = '/api/v1/ServiceAftale/GetAvailableKomponentTyper';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableKomponentTyper()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableKomponentTyper$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoKomponentTypeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetAvailableKomponentTyperPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoKomponentTypeDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvailableKomponentTyper$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableKomponentTyper(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoKomponentTypeDto>> {

    return this.getAvailableKomponentTyper$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoKomponentTypeDto>>) => r.body as Array<OkEgisServiceModelsDtoKomponentTypeDto>)
    );
  }

  /**
   * Path part for operation getServiceAftaleForKunde
   */
  static readonly GetServiceAftaleForKundePath = '/api/v1/ServiceAftale/GetServiceAftaleForKunde';

  /**
   * Returns a serviceaftale for a aftalenr.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceAftaleForKunde()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceAftaleForKunde$Response(params: {

    /**
     * Aftalenr
     */
    okKundeAftaleNr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftaleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceAftaleForKundePath, 'get');
    if (params) {
      rb.query('okKundeAftaleNr', params.okKundeAftaleNr, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftaleResponse>;
      })
    );
  }

  /**
   * Returns a serviceaftale for a aftalenr.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceAftaleForKunde$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceAftaleForKunde(params: {

    /**
     * Aftalenr
     */
    okKundeAftaleNr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetServiceaftaleResponse> {

    return this.getServiceAftaleForKunde$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftaleResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftaleResponse)
    );
  }

  /**
   * Path part for operation updateServiceaftaleRabat
   */
  static readonly UpdateServiceaftaleRabatPath = '/api/v1/ServiceAftale/UpdateServiceaftaleRabat';

  /**
   * Updates rabat on a serviceaftale with contents of the dto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceaftaleRabat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceaftaleRabat$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoServiceaftaleRabatUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateServiceaftaleRabatPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto>;
      })
    );
  }

  /**
   * Updates rabat on a serviceaftale with contents of the dto.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceaftaleRabat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceaftaleRabat(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoServiceaftaleRabatUpdateDto
  }): Observable<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto> {

    return this.updateServiceaftaleRabat$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto)
    );
  }

  /**
   * Path part for operation removeRabat
   */
  static readonly RemoveRabatPath = '/api/v1/ServiceAftale/RemoveRabat';

  /**
   * Remove rabat on a serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeRabat()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeRabat$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.RemoveRabatPath, 'post');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * Remove rabat on a serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeRabat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeRabat(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.removeRabat$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation updateServiceaftaleDates
   */
  static readonly UpdateServiceaftaleDatesPath = '/api/v1/ServiceAftale/UpdateServiceaftaleDates';

  /**
   * Updates dates on a serviceaftale with contents of the dto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceaftaleDates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceaftaleDates$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoServiceaftaleDatesUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateServiceaftaleDatesPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto>;
      })
    );
  }

  /**
   * Updates dates on a serviceaftale with contents of the dto.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceaftaleDates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceaftaleDates(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoServiceaftaleDatesUpdateDto
  }): Observable<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto> {

    return this.updateServiceaftaleDates$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleUpdateResponseDto)
    );
  }

  /**
   * Path part for operation getServiceaftaleTags
   */
  static readonly GetServiceaftaleTagsPath = '/api/v1/ServiceAftale/GetServiceaftaleTags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaleTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleTags$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleTagDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftaleTagsPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleTagDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaleTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleTags(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceaftaleTagDto>> {

    return this.getServiceaftaleTags$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleTagDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceaftaleTagDto>)
    );
  }

  /**
   * Path part for operation getServiceaftaleStates
   */
  static readonly GetServiceaftaleStatesPath = '/api/v1/ServiceAftale/GetServiceaftaleStates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaleStates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleStates$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleStateDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftaleStatesPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleStateDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaleStates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleStates(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceaftaleStateDto>> {

    return this.getServiceaftaleStates$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceaftaleStateDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceaftaleStateDto>)
    );
  }

  /**
   * Path part for operation getUpcomingChanges
   */
  static readonly GetUpcomingChangesPath = '/api/v1/ServiceAftale/GetUpcomingChanges';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUpcomingChanges()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUpcomingChanges$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoUpcomingChangesDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetUpcomingChangesPath, 'get');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoUpcomingChangesDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUpcomingChanges$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUpcomingChanges(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoUpcomingChangesDto> {

    return this.getUpcomingChanges$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoUpcomingChangesDto>) => r.body as OkEgisServiceModelsDtoUpcomingChangesDto)
    );
  }

  /**
   * Path part for operation getServiceaftaleChangesForServiceordre
   */
  static readonly GetServiceaftaleChangesForServiceordrePath = '/api/v1/ServiceAftale/GetServiceaftaleChangesForServiceordre';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceaftaleChangesForServiceordre()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleChangesForServiceordre$Response(params: {
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoChangeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetServiceaftaleChangesForServiceordrePath, 'get');
    if (params) {
      rb.query('serviceordreNo', params.serviceordreNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoChangeDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getServiceaftaleChangesForServiceordre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceaftaleChangesForServiceordre(params: {
    serviceordreNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoChangeDto>> {

    return this.getServiceaftaleChangesForServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoChangeDto>>) => r.body as Array<OkEgisServiceModelsDtoChangeDto>)
    );
  }

  /**
   * Path part for operation cancelServiceaftale
   */
  static readonly CancelServiceaftalePath = '/api/v1/ServiceAftale/CancelServiceaftale';

  /**
   * Cancels a serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelServiceaftale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelServiceaftale$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Request object
     */
    body?: OkEgisServiceModelsDtoCancelServiceaftaleRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.CancelServiceaftalePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * Cancels a serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelServiceaftale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelServiceaftale(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Request object
     */
    body?: OkEgisServiceModelsDtoCancelServiceaftaleRequest
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.cancelServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation fakturastop
   */
  static readonly FakturastopPath = '/api/v1/ServiceAftale/Fakturastop';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fakturastop()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fakturastop$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestFakturaStopRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.FakturastopPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fakturastop$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fakturastop(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestFakturaStopRequest
  }): Observable<void> {

    return this.fakturastop$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation updateTags
   */
  static readonly UpdateTagsPath = '/api/v1/ServiceAftale/UpdateTags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTags$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTagsRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateTagsPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTags(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTagsRequest
  }): Observable<void> {

    return this.updateTags$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation updateServiceabonnement
   */
  static readonly UpdateServiceabonnementPath = '/api/v1/ServiceAftale/UpdateServiceabonnement';

  /**
   * Updates serviceabonnement on serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceabonnement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceabonnement$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateServiceabonnementRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateServiceabonnementPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Updates serviceabonnement on serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceabonnement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceabonnement(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateServiceabonnementRequest
  }): Observable<void> {

    return this.updateServiceabonnement$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation updateServiceOrdreNote
   */
  static readonly UpdateServiceOrdreNotePath = '/api/v1/ServiceAftale/UpdateServiceOrdreNote';

  /**
   * Updates serviceordrenote on serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceOrdreNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceOrdreNote$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateServiceOrdreNoteRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateServiceOrdreNotePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Updates serviceordrenote on serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceOrdreNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceOrdreNote(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateServiceOrdreNoteRequest
  }): Observable<void> {

    return this.updateServiceOrdreNote$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation updateFastOrdreNote
   */
  static readonly UpdateFastOrdreNotePath = '/api/v1/ServiceAftale/UpdateFastOrdreNote';

  /**
   * Updates fastnote on serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFastOrdreNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFastOrdreNote$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateFastOrdreNoteRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateFastOrdreNotePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * Updates fastnote on serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFastOrdreNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFastOrdreNote(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateFastOrdreNoteRequest
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.updateFastOrdreNote$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation reactivate
   */
  static readonly ReactivatePath = '/api/v1/ServiceAftale/Reactivate';

  /**
   * Updates notes on serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reactivate$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestReactivateServiceaftaleRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.ReactivatePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * Updates notes on serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reactivate(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestReactivateServiceaftaleRequest
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.reactivate$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation updateServiceaftalePartner
   */
  static readonly UpdateServiceaftalePartnerPath = '/api/v1/ServiceAftale/UpdatePartner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceaftalePartner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceaftalePartner$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateServiceaftalePartnerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateServiceaftalePartnerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceaftalePartner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceaftalePartner(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateServiceaftalePartnerRequest
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.updateServiceaftalePartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation updateMultiplePartner
   */
  static readonly UpdateMultiplePartnerPath = '/api/v1/ServiceAftale/UpdateMultiplePartner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMultiplePartner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMultiplePartner$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateMultiplePartnerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseUpdateMultiplePartnerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateMultiplePartnerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseUpdateMultiplePartnerResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateMultiplePartner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMultiplePartner(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateMultiplePartnerRequest
  }): Observable<OkEgisServiceModelsResponseUpdateMultiplePartnerResponse> {

    return this.updateMultiplePartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseUpdateMultiplePartnerResponse>) => r.body as OkEgisServiceModelsResponseUpdateMultiplePartnerResponse)
    );
  }

  /**
   * Path part for operation updateServiceAftaleHenviser
   */
  static readonly UpdateServiceAftaleHenviserPath = '/api/v1/ServiceAftale/UpdateServiceAftaleHenviser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateServiceAftaleHenviser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceAftaleHenviser$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateHenviserRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateServiceAftaleHenviserPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateServiceAftaleHenviser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateServiceAftaleHenviser(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateHenviserRequest
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.updateServiceAftaleHenviser$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation updateOpkraevningsinterval
   */
  static readonly UpdateOpkraevningsintervalPath = '/api/v1/ServiceAftale/UpdateOpkraevningsinterval';

  /**
   * Updates opkraevningsinterval on serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOpkraevningsinterval()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOpkraevningsinterval$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateOpkraevningsintervalRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.UpdateOpkraevningsintervalPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * Updates opkraevningsinterval on serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateOpkraevningsinterval$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOpkraevningsinterval(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateOpkraevningsintervalRequest
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.updateOpkraevningsinterval$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation setOpkraevningsdatoToNextServiceinterval
   */
  static readonly SetOpkraevningsdatoToNextServiceintervalPath = '/api/v1/ServiceAftale/SetOpkraevningsdatoToNextServiceinterval/{serviceaftaleId}';

  /**
   * Set Opkraevningsdato to next serviceinterval.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setOpkraevningsdatoToNextServiceinterval()` instead.
   *
   * This method doesn't expect any request body.
   */
  setOpkraevningsdatoToNextServiceinterval$Response(params: {
    serviceaftaleId: number;
    causeRemark?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.SetOpkraevningsdatoToNextServiceintervalPath, 'post');
    if (params) {
      rb.path('serviceaftaleId', params.serviceaftaleId, {});
      rb.query('causeRemark', params.causeRemark, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>;
      })
    );
  }

  /**
   * Set Opkraevningsdato to next serviceinterval.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setOpkraevningsdatoToNextServiceinterval$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setOpkraevningsdatoToNextServiceinterval(params: {
    serviceaftaleId: number;
    causeRemark?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceaftaleDto> {

    return this.setOpkraevningsdatoToNextServiceinterval$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceaftaleDto>) => r.body as OkEgisServiceModelsDtoServiceaftaleDto)
    );
  }

  /**
   * Path part for operation getTerminationCauses
   */
  static readonly GetTerminationCausesPath = '/api/v1/ServiceAftale/GetTerminationCauses';

  /**
   * Get defined terminationcauses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTerminationCauses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTerminationCauses$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoTerminationCauseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetTerminationCausesPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoTerminationCauseDto>>;
      })
    );
  }

  /**
   * Get defined terminationcauses.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTerminationCauses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTerminationCauses(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoTerminationCauseDto>> {

    return this.getTerminationCauses$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoTerminationCauseDto>>) => r.body as Array<OkEgisServiceModelsDtoTerminationCauseDto>)
    );
  }

  /**
   * Path part for operation getPartnerInfoForServiceaftale
   */
  static readonly GetPartnerInfoForServiceaftalePath = '/api/v1/ServiceAftale/GetPartnerInfoForServiceaftale';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerInfoForServiceaftale()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerInfoForServiceaftale$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerInfoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetPartnerInfoForServiceaftalePath, 'get');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerInfoDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerInfoForServiceaftale$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerInfoForServiceaftale(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnerInfoDto> {

    return this.getPartnerInfoForServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerInfoDto>) => r.body as OkEgisServiceModelsDtoPartnerInfoDto)
    );
  }

  /**
   * Path part for operation removeUpcomingChanges
   */
  static readonly RemoveUpcomingChangesPath = '/api/v1/ServiceAftale/RemoveUpcomingChanges';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUpcomingChanges()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUpcomingChanges$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestRemoveUpcomingChangesRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoUpcomingChangesDto>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.RemoveUpcomingChangesPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoUpcomingChangesDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeUpcomingChanges$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUpcomingChanges(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestRemoveUpcomingChangesRequest
  }): Observable<OkEgisServiceModelsDtoUpcomingChangesDto> {

    return this.removeUpcomingChanges$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoUpcomingChangesDto>) => r.body as OkEgisServiceModelsDtoUpcomingChangesDto)
    );
  }

  /**
   * Path part for operation anonymise
   */
  static readonly AnonymisePath = '/api/v1/ServiceAftale/Anonymise';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymise()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymise$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.AnonymisePath, 'put');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `anonymise$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymise(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.anonymise$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getAftalerAffectedByAbonnementChange
   */
  static readonly GetAftalerAffectedByAbonnementChangePath = '/api/v1/ServiceAftale/GetAftalerAffectedByAbonnementChange';

  /**
   * Returns a list of available abonnements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAftalerAffectedByAbonnementChange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAftalerAffectedByAbonnementChange$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoUpdateServiceAbonnementRequestDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.GetAftalerAffectedByAbonnementChangePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Returns a list of available abonnements.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAftalerAffectedByAbonnementChange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAftalerAffectedByAbonnementChange(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoUpdateServiceAbonnementRequestDto
  }): Observable<number> {

    return this.getAftalerAffectedByAbonnementChange$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation validateOpkraevningsinterval
   */
  static readonly ValidateOpkraevningsintervalPath = '/api/v1/ServiceAftale/ValidateOpkraevningsinterval';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateOpkraevningsinterval()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateOpkraevningsinterval$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestValidateOpkraevningsintervalRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseValidateOpkraevningsintervalResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceAftaleService.ValidateOpkraevningsintervalPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseValidateOpkraevningsintervalResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `validateOpkraevningsinterval$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateOpkraevningsinterval(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestValidateOpkraevningsintervalRequest
  }): Observable<OkEgisServiceModelsResponseValidateOpkraevningsintervalResponse> {

    return this.validateOpkraevningsinterval$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseValidateOpkraevningsintervalResponse>) => r.body as OkEgisServiceModelsResponseValidateOpkraevningsintervalResponse)
    );
  }

}
